import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
  margin-top: 5.18rem;
  margin-bottom: 128px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2``;

export const List = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
`;

export const Item = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-width: 300px;
`;

export const Step = styled.div`
  font-size: 56px;
  min-width: 48px;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: rgba(255, 255, 255, 0.2);
`;

export const Text = styled.div`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  padding-top: 12px;
  padding-bottom: 8px;
`;

export const Description = styled.div`
  color: rgba(255, 255, 255, 0.75);
  font-size: 16px;
  line-height: 24px;
`;
